import React from 'react';
import * as Styles from './CreateTicketStep3.style';
import { StepLabel } from 'components/step-label/StepLabel';
import { useTranslation } from 'react-i18next';

const CreateTicketStep3 = ({ formikProp }) => {
  const { t } = useTranslation();
  const { values, handleChange, errors, touched, handleBlur } = formikProp;
  return (
    <Styles.CreateTicketStep3SC>
      <StepLabel id="ST3" stepCount={'admin/tickets/create.step3_string1'}>
        {t('admin/tickets/create.step3_string2')}
      </StepLabel>
      <Styles.SubmitReply>
        <Styles.TextArea>
          <textarea
            name={'note'}
            value={values['note']}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors['note']}
            touched={touched['note']}
            rows="5"
          />
        </Styles.TextArea>
      </Styles.SubmitReply>
    </Styles.CreateTicketStep3SC>
  );
};
export default CreateTicketStep3;
